var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashKarmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CashKarmaIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-24.7019964%",
    x2: "50%",
    y2: "132.102633%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3CC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.4205578%",
    y1: "24.661072%",
    x2: "19.8534369%",
    y2: "78.6163863%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39547",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6D02",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CashKarmaIcon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-cash",
    transform: "translate(71, 120)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 9.56896552,
    y: 70.3406884,
    width: 350.862069,
    height: 192.056487
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.431034,262.397176 L360.431034,70.3406884 L231.887931,83.1444543 C123.758621,94.0276552 41.4655172,153.245072 41.4655172,262.397176 L41.4655172,262.397176 L360.431034,262.397176 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12069,158.686673 L177.344828,153.565166 C171.284483,151.964695 167.456897,146.843189 167.456897,140.7614 C167.456897,133.399235 173.517241,127.317446 180.853448,127.317446 L190.422414,127.317446 C197.12069,127.317446 202.543103,132.759047 202.543103,139.481024 C202.543103,144.922624 206.689655,149.083848 212.112069,149.083848 C217.534483,149.083848 221.681034,144.922624 221.681034,139.481024 C221.681034,123.476317 209.87931,110.352457 194.568966,108.431892 L194.568966,104.270668 C194.568966,98.8290674 190.422414,94.6678435 185,94.6678435 C179.577586,94.6678435 175.431034,98.8290674 175.431034,104.270668 L175.431034,108.751986 C160.12069,111.312739 148.318966,124.756693 148.318966,140.7614 C148.318966,155.805825 158.525862,168.609591 172.87931,172.450721 L192.655172,177.252133 C198.715517,178.852604 202.543103,183.97411 202.543103,190.055899 C202.543103,197.418064 196.482759,203.499853 189.146552,203.499853 L179.577586,203.499853 C172.87931,203.499853 167.456897,198.058252 167.456897,191.336275 C167.456897,185.894675 163.310345,181.733451 157.887931,181.733451 C152.465517,181.733451 148.318966,185.894675 148.318966,191.336275 C148.318966,207.340983 160.12069,220.464843 175.431034,222.385407 L175.431034,226.546631 C175.431034,231.988232 179.577586,236.149456 185,236.149456 C190.422414,236.149456 194.568966,231.988232 194.568966,226.546631 L194.568966,222.065313 C209.87931,219.50456 221.681034,206.060606 221.681034,190.055899 C221.681034,175.011474 211.474138,162.207708 197.12069,158.686673 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.431034,272 L9.56896552,272 C4.14655172,272 0,267.838776 0,262.397176 L0,70.3406884 C0,64.899088 4.14655172,60.7378641 9.56896552,60.7378641 L360.431034,60.7378641 C365.853448,60.7378641 370,64.899088 370,70.3406884 L370,262.397176 C370,267.838776 365.853448,272 360.431034,272 Z M19.137931,252.794351 L350.862069,252.794351 L350.862069,79.9435128 L19.137931,79.9435128 L19.137931,252.794351 Z",
    id: "Shape",
    fill: "#AA4D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.431034,51.1350397 C242.732759,51.1350397 156.931034,40.2518388 51.0344828,21.0461901 L51.0344828,41.5322154 C51.0344828,46.9738158 46.887931,51.1350397 41.4655172,51.1350397 C36.0431034,51.1350397 31.8965517,46.9738158 31.8965517,41.5322154 L31.8965517,9.52280082 C31.8965517,6.64195352 33.1724138,4.08120035 35.4051724,2.16063548 C37.637931,0.240070609 40.5086207,-0.400117682 43.3793103,0.240070609 L46.25,0.8802589 C154.698276,20.4060018 241.137931,31.929391 360.431034,31.929391 C365.853448,31.929391 370,36.0906149 370,41.5322154 C370,46.9738158 365.853448,51.1350397 360.431034,51.1350397 Z",
    id: "Path",
    fill: "#AA4D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashKarmaIcon);
export default __webpack_public_path__ + "static/media/CashKarmaIcon.13629a5e404632b43720234fdb1f3b14.svg";
export { ForwardRef as ReactComponent };